// extracted by mini-css-extract-plugin
export default {"varselMain":"varselConfirm_varselMain__xO+kX","content":"varselConfirm_content__y6dN7"};